import { useTranslation } from 'react-i18next';

import MaskInput from 'components/MaskedInput';
import CurrentStatusField from 'features/Croptimizer/components/Fields/CurrentStatusField';
import TargetStatusField from 'features/Croptimizer/components/Fields/TargetStatusField';
import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';

interface StatusBoardStatusSectionProps {
  currentSec: string;
  setCurrentSec: (value: string) => void;
  currentSecAuto: string;
  errorCurrentSecHandle: string;
  targetSec: string;
  errorTargetSec: string;
}

export const StatusBoardStatusSection = ({
  currentSec,
  setCurrentSec,
  currentSecAuto,
  errorCurrentSecHandle,
  targetSec,
  errorTargetSec,
}: StatusBoardStatusSectionProps) => {
  const { t } = useTranslation();
  const { isExpertMode } = useCroptimizer();
  
  return (
    <div className="flex justify-between md:flex-col py-8 border-b border-primitiveGrey">
      <div className="w-1/2 border-r border-primitiveGrey md:border-b md:border-r-0 pr-8 md:w-full md:pr-0 pb-0">
        <div className="text-black font-bold text-xl md:text-lg md:mt-2">
          {t('currentStatus')}
        </div>
        <div className="mt-4">
          <CurrentStatusField />
        </div>
        {isExpertMode &&
          <div className="mt-4">
            <MaskInput
              value={currentSec}
              className="w-full h-[48px]"
              titleClassName="top-[-9px] left-[8px]"
              title="S/CEC"
              onChange={setCurrentSec}
              isGreyText={currentSec === currentSecAuto}
              redBorder={errorCurrentSecHandle.length > 0}
              suffix=" %"
              isBlueBg
              decimalLimit={2}
            />
            <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
              {errorCurrentSecHandle.length > 0 && (
                <div> {errorCurrentSecHandle}</div>
              )}
            </div>
          </div>
        }
      </div>
      <div className="w-1/2 pl-8 md:w-full md:pl-0">
        <div className="text-black font-bold text-xl md:text-lg md:mt-6">
          {t('targetStatus')}
        </div>
        <div className="mt-4">
          <TargetStatusField />
        </div>
        {isExpertMode &&
          <div className="mt-4">
            <MaskInput
              disabled
              value={targetSec}
              className="w-full h-[48px] w-[536px]"
              titleClassName="top-[-9px] left-[8px] bg-disable-gradient"
              title="S/CEC"
              isGreyText
              suffix=" %"
              isBlueBg
            />
            <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
              {errorTargetSec.length > 0 && <div> {errorTargetSec}</div>}
            </div>
          </div>
        }
      </div>
    </div>
  );
};
